import assign from 'object-assign';
import { EventEmitter } from 'events';
import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import AdminConstants from '../constants/AdminConstants';
const ActionTypes = AdminConstants.ActionTypes;
const CHANGE_EVENT = 'BILL_OF_LADING_CHANGED';
var BOL_RESPONSE = {};
const BillOfLadingStore = assign({}, EventEmitter.prototype, {
    emitChange() {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    setBillOfLading({ bol, success, errorMessage }) {
        BOL_RESPONSE = { bol, success, errorMessage };
    },
    resetBillOfLading() {
        BOL_RESPONSE = null;
    },
    getBillOfLading() {
        return BOL_RESPONSE;
    },
});
BillOfLadingStore.dispatchToken = AdminAppDispatcher.register(function (payload) {
    const action = payload.action;
    switch (action.type) {
        case ActionTypes.GENERATE_BILL_OF_LADING_SUCCESS:
            BillOfLadingStore.setBillOfLading({
                success: true,
                errorMessage: null,
                bol: payload.action.bol,
            });
            BillOfLadingStore.emitChange();
            break;
        case ActionTypes.GENERATE_BILL_OF_LADING_FAIL:
            BillOfLadingStore.setBillOfLading({
                success: false,
                errorMessage: action.error,
            });
            BillOfLadingStore.emitChange();
            break;
        default:
            break;
    }
});
export default BillOfLadingStore;
